import React, { useState } from 'react';
import './index.scss';

const SpHeaderSideMenu = () => {
  const [ open, setOpen ] = useState(false);
  const handleOpen = () => {
    setOpen(!open);
    // メニュー開く時、画面スクロールを不可にする（サイドメニューを固定するため）
    if (!open) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'relative';
      document.body.style.height = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height = '';
    }
  };
  return (
    <div className='SpHeaderSideMenu'>
      <button type="button" className="side-menu" aria-expanded={open} onClick={handleOpen}>
        <span className="side-menu_border side-menu_border__1" />
        <span className="side-menu_border side-menu_border__2" />
        <span className="side-menu_text" />
      </button>
      <div id="drawer" className="drawer" aria-expanded={open}>
        <div className="drawer-backdrop" />
        <nav className="drawer-nav">
          <ul className="drawer-nav_list">
            <li><a href="/cl/service" target="_blank">サービス</a></li>
            <li><a href="/cl/branch" target="_blank">拠点・連絡先</a></li>
            <li><a href="/cl/column" target="_blank">コラム</a></li>
            <li><a href="/cl/seminar" target="_blank">セミナー</a></li>
          </ul>
        </nav>
      </div>
    </div>      
  );
};

export default SpHeaderSideMenu;
